"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _default = exports["default"] = function _default(data, projectId) {
  var variableTypes = {
    quantitative: 'Quantitative',
    qualitative: 'Qualitative',
    summary_usage: 'Summary Usage'
  };
  var variables = {};
  var _iterator = _createForOfIteratorHelper(data.metrics.variableList),
    _step;
  try {
    var _loop = function _loop() {
      var variable = _step.value;
      var type = variable.type;
      var _iterator2 = _createForOfIteratorHelper(variable.key.assignment.deploymentList),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var deploymentId = _step2.value.deploymentId;
          variables[deploymentId] = variables[deploymentId] || [];
          var typeGroup = variables[deploymentId].find(function (item) {
            return item.id === "".concat(type).concat(deploymentId);
          });
          if (!typeGroup) {
            typeGroup = {
              id: "".concat(type).concat(deploymentId),
              label: "".concat(variableTypes[type] || type, " Metrics"),
              children: []
            };
            variables[deploymentId].push(typeGroup);
          }
          typeGroup.children.push({
            id: "variables".concat(deploymentId, ".variables.").concat(variable.reportHeader),
            query: "variables".concat(deploymentId, ":assignmentProgress(deploymentId:").concat(deploymentId, ").variables.").concat(variable.reportHeader),
            label: variable.reportHeader,
            type: 'string'
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var map = {};
  data.flows.assignmentList.forEach(function (assignment) {
    var deployments = assignment.deploymentList.map(function (deployment) {
      return {
        id: "deployment".concat(deployment.deploymentId),
        label: deployment.label,
        children: [{
          id: "progress".concat(deployment.deploymentId, ".status"),
          query: "progress".concat(deployment.deploymentId, ":assignmentProgress(deploymentId:").concat(deployment.deploymentId, ").status"),
          label: 'Status',
          type: 'string'
        }, {
          id: "progress".concat(deployment.deploymentId, ".startedDate"),
          query: "progress".concat(deployment.deploymentId, ":assignmentProgress(deploymentId:").concat(deployment.deploymentId, ").startedDate"),
          label: 'Started Date',
          type: 'string'
        }, {
          id: "progress".concat(deployment.deploymentId, ".completedDate"),
          query: "progress".concat(deployment.deploymentId, ":assignmentProgress(deploymentId:").concat(deployment.deploymentId, ").completedDate"),
          label: 'Completed Date',
          type: 'string'
        }].concat(_toConsumableArray(variables[deployment.deploymentId] || []))
      };
    });
    if (deployments.length === 0) {
      return;
    }
    map[assignment.groupId] = map[assignment.groupId] || [];
    map[assignment.groupId].push({
      id: "assignment".concat(assignment.assignmentId),
      label: assignment.label,
      children: deployments
    });
  });
  var projects = data.groups.questprojectList.map(function (project) {
    return {
      id: "project".concat(project.group.groupId),
      projectId: project.group.groupId,
      label: project.group.label,
      children: map[project.group.groupId] || []
    };
  }).filter(function (project) {
    return project.children.length > 0;
  });
  if (projectId) {
    var projectInfo = projects.find(function (project) {
      return project.projectId === projectId;
    });
    return projectInfo ? projectInfo.children : [];
  }
  return projects;
};